<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { ChipsColorI } from '@/typescript/types/ui-components/BaseChipsI'
  export default defineComponent({
    name: 'BaseChips',
    props: {
      content: {
        type: String,
        default: 'Chips',
      },
      color: {
        type: String as PropType<ChipsColorI>,
        default: 'orange',
        validate(val: string) {
          return ['orange', 'dark_orange', 'blue', 'dark_blue', 'green', 'gray', 'light_gray', 'red', 'pink'].includes(
            val,
          )
        },
      },
    },
  })
</script>

<template>
  <div
    class="chips"
    :class="{
      'blue-chips': color === 'blue',
      'dark-blue-chips': color === 'dark_blue',
      'orange-chips': color === 'orange',
      'dark-orange-chips': color === 'dark_orange',
      'green-chips': color === 'green',
      'gray-chips': color === 'gray',
      'red-chips': color === 'red',
      'pink-chips': color === 'pink',
      'outline-turquoise': color === 'outline_turquoise',
      'light-gray': color === 'light_gray',
    }"
  >
    {{ content }}
  </div>
</template>

<style scoped lang="scss">
  .chips {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 8px;
    &.blue-chips {
      background-color: var(--color-chips-blue-bg);
      color: var(--color-chips-blue);
    }
    &.dark-blue-chips {
      background-color: var(--color-chips-dark-blue-bg);
      color: var(--color-chips-dark-blue);
    }
    &.orange-chips {
      background-color: var(--color-chips-orange-bg);
      color: var(--color-chips-orange);
    }
    &.dark-orange-chips {
      background-color: var(--color-chips-dark-orange-bg);
      color: var(--color-chips-dark-orange);
    }
    &.green-chips {
      background-color: var(--color-chips-green-bg);
      color: var(--color-chips-green);
    }
    &.gray-chips {
      background-color: var(--color-chips-gray-bg);
      color: var(--color-chips-gray);
    }
    &.light-gray {
      background-color: var(--color-chips-light-gray-bg);
      color: var(--color-chips-light-gray);
    }
    &.red-chips {
      background-color: var(--color-chips-red-bg);
      color: var(--color-chips-red);
    }
    &.pink-chips {
      background-color: var(--color-chips-pink-bg);
      color: var(--color-chips-pink);
    }
    &.outline-turquoise {
      background-color: var(--color-chips-turquoise-bg);
      color: var(--color-chips-turquoise);
      border: 1px solid var(--color-chips-turquoise);
    }
  }
</style>
